import Base, { baseInit } from './base';

export class TrackingPixel extends Base {
  id = null; // Integer
  name = null; // String

  constructor(data) {
    super(data);
    baseInit(this, data);
  }
}
